import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'enrollments';

/**
 * Fetch enrollments for a user from Firestore (admin-activated paid courses).
 * Returns array of course-like objects for display in My Learning.
 */
export async function getEnrollmentsForUser(userId) {
  if (!userId) return [];
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId)
  );
  const snap = await getDocs(q);
  const list = [];
  snap.forEach((docSnap) => {
    const d = docSnap.data();
    list.push({
      id: d.courseId,
      title: d.courseTitle || '',
      thumbnail: d.thumbnail || '',
      banner: d.banner || '',
      level: d.level || '',
      duration: d.duration || '',
      instructor: d.instructor || 'Instructor',
      price: d.price ?? 'Free',
      progress: d.progress ?? 0,
    });
  });
  return list;
}
